module.exports = __webpack_public_path__ + "img/vimeo.69f77472.png";